export default __webpack_public_path__ + "static/media/remix-preview-empty.76f1dbc9.svg";